// HDS-R(旧名:MCI)用API.

import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as AWS from '../constants/AWS';
import * as HDSRConst from '../constants/HDSR';

/**
 * HDS-RのAPIクラス.
 *
 * @export
 * @class HDSRAPI
 */
export class HDSRAPI {
  /** インスタンス */
  private static _instance: HDSRAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): HDSRAPI | null {
    // _inctanceが存在しない場合に、new MoffAPI()を実行する。
    if (!this._instance) {
      this._instance = new HDSRAPI();
      
      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_HDSR_API_URL);
      const API_KEY = String(process.env.REACT_APP_HDSR_API_KEY);

      if (API_BASE_URL === 'undefined') {
        alert('.envにREACT_APP_HDSR_API_URLの設定がありません.');
        return null;
      }

      if (API_KEY === 'undefined') {
        alert('.envにRREACT_APP_HDSR_API_KEYの設定がありません.');
        return null;
      }

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken(),
              'x-api-key': API_KEY
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  /**
   * HDS-R(旧名:MCI)最新件数取得.
   * UNIX Timeパラメータを渡すと、その月での最新の日付の合計値を返却.
   * パラメータの年月に1件もデータがない場合は以前の月の中での最新の日付の合計を返す.
   *
   * @param {string} uniqueId
   * @param {string} timestamp UNIX Time
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof BarthelAPI
   */
  public getHDSRLatestCount(
    uniqueId: string, timestamp: number, requestFunc: Function, fetchedFunc: Function): any {
    // query_parameter
    const params = {
      timestamp: timestamp,
    };

    const url = `/mci/users/${uniqueId}/latest`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url, { params })
        .then(function(response: any) {
          dispatch(fetchedFunc(HDSRConst.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          dispatch(fetchedFunc(HDSRConst.ERROR, error));
        });
    };
  }

  /**
   * MCI結果一覧取得.
   *
   * @param {string} uniqueId
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof HDSRAPI
   */
  public getAllHDSRRecords(
    uniqueId: string, requestFunc: Function, fetchedFunc: Function): any {
    const url = `/mci/users/${uniqueId}/scores`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(HDSRConst.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          dispatch(fetchedFunc(HDSRConst.ERROR, error));
        });
    };
  }

  /**
   * MCI結果詳細の取得.
   *
   * @param {string} uniqueId
   * @param {string} timeStamp タイムスタンプ.
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof HDSRAPI
   */
  public getHDSRRecordDetail(
    uniqueId: string, timeStamp: number, requestFunc: Function, fetchedFunc: Function): any {
    const url = `/mci/users/${uniqueId}/scores/${timeStamp}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(HDSRConst.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          dispatch(fetchedFunc(HDSRConst.ERROR, error));
        });
    };
  }
}


// WEBPACK FOOTER //
// ./src/api/HDSRAPI.tsx